import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'

/**
 * Determines whether the current channel ID and webcast ID has fetched data successfully
 * @param state The Redux state
 */

const getHasData = (state: State): boolean => state.user.status.hasData
const getHasError = (state: State): boolean => state.user.status.hasError

export default createSelector(
  [getHasData, getHasError],
  (hasData, hasError) => {

    return (!hasData && !hasError) ? null : hasData

  })
